import { FC } from "react";

interface IAgendrixSetupFieldsPanel {
}
export const AgendrixSetupFieldsPanel: FC<
    IAgendrixSetupFieldsPanel
> = ({ }) => {

    return (
        <>
          Coming soon...
        </>
    );
};
